import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import React, { useState } from 'react';
import { GET_SPECIES } from 'Util/queries';
const { Option } = Select;

function SpeciesDropdown({ onChange, ...rest }) {

    const [list, setList] = useState([])

    const { data } = useQuery(GET_SPECIES, {
        onCompleted() {
            setList(data.product_species)
        }
    });

    return (
        <div>
            <Select
                {...rest}
                style={{ width: 300 }}
                placeholder="Select a species"
                onChange={onChange}
            >
                { list.map(v=><Option value={v.id} key={`species-dd-opt${v.id}`}>{v.label}</Option>) }
            </Select>
        </div>
    )
}

export default SpeciesDropdown
